var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { setTableConfig, setTableOrdering, setTablePage } from '../reducers/tablesPrefs';
import { map, find } from 'lodash';
import { createActivityAction, deleteActivityAction, updateActivityAction } from '../reducers/reduxActivities';
import { fetchAllUsersActivitiesStats } from '../reducers/usersWithActivities';
import { updateTakeAction } from '../reducers/takes';
import { fetchAllAssetsStats, updateAssetAction } from '../reducers/assets';
import { setAndApplyInputFilters, resetReduxTableFilters } from '../reducers/tablesFilters';
import { setStatsOpen } from '../reducers/stats';
import { createAndDeleteTakeFlagsAction } from '../reducers/takesFlags';
import { createAndDeleteAssetFlagsAction } from '../reducers/reduxAssetFlags';
import { updateAndDeleteAssetLinksAction } from '../reducers/reduxAssetLinks';
import { createUpdateAndDeleteDynamicApprovalValueAction } from '../reducers/reduxDynamicApprovalValues';
import { fetchAllTasksStats, updateTaskAction } from '../reducers/tasks';
import { setAssetId } from '../reducers/tableFollowUpPrefs';
import { filtersToQueries } from 'app/filtersUtils.js';
const listenerMiddleware = createListenerMiddleware();
const getOrderingKeys = ({ sortingKeys = {} } = {}) => {
    const sortingsStrings = map(sortingKeys, (sort) => {
        return sort.key;
    });
    return sortingsStrings.join();
};
// tables: sorting
listenerMiddleware.startListening({
    actionCreator: setTableConfig,
    effect: (action_1, _a) => __awaiter(void 0, [action_1, _a], void 0, function* (action, { getState, dispatch }) {
        var _b;
        const tableId = getState().tablesPrefs.activeTableId;
        const tableSortBy = (_b = getState().tablesPrefs.data[tableId]) === null || _b === void 0 ? void 0 : _b.sortBy;
        const sortingString = getOrderingKeys(tableSortBy);
        if (sortingString)
            dispatch(setTableOrdering(sortingString));
    }),
});
// fetch stats after CRUD on activities
listenerMiddleware.startListening({
    matcher: isAnyOf(createActivityAction, deleteActivityAction, updateActivityAction),
    effect: (action_1, _a) => __awaiter(void 0, [action_1, _a], void 0, function* (action, { getState, dispatch }) {
        const pathname = getState().router.pathname;
        // if (pathname.includes('my-tasks')) return
        const viewsWithNoStats = ['my-hours', 'my-allotment-hours', 'my-tasks'];
        const viewHasStats = viewsWithNoStats.some((str) => pathname.includes(str));
        if (!viewHasStats) {
            const tableQueries = getState().allUsersWithActivities.tableQueries;
            dispatch(fetchAllUsersActivitiesStats(tableQueries));
        }
    }),
});
// tables: stats
listenerMiddleware.startListening({
    matcher: isAnyOf(createAndDeleteAssetFlagsAction, createAndDeleteTakeFlagsAction, updateAndDeleteAssetLinksAction, createUpdateAndDeleteDynamicApprovalValueAction, updateAssetAction, updateTakeAction, updateTaskAction, setStatsOpen, setAssetId, resetReduxTableFilters, setAndApplyInputFilters),
    effect: (action_1, _a) => __awaiter(void 0, [action_1, _a], void 0, function* (action, { getState, dispatch }) {
        var _b, _c;
        const { statsIsOpen } = getState().statsStatus;
        const tableId = getState().tablesPrefs.activeTableId;
        // TODO : fetch stats only if columns have stats (check TableResources component)
        if (!statsIsOpen || !tableId)
            return;
        const filters = (_b = getState().tablesFilters) === null || _b === void 0 ? void 0 : _b.filtersForQueries[tableId];
        const { queries: filtersQueries } = filtersToQueries(filters !== null && filters !== void 0 ? filters : []);
        switch (true) {
            case tableId === 'PlannerTaskTable':
                dispatch(fetchAllTasksStats({ tableId, filtersQueries }));
                break;
            case tableId.includes('follow-up'):
                const { trackingSchemaId, assetId } = getState().tableFollowUpPrefs;
                const asset = find((_c = getState().assets) === null || _c === void 0 ? void 0 : _c.resources, (asset) => asset.id === assetId);
                const queries = Object.assign(Object.assign({}, filtersQueries), { uuid__in: ['sh', 'mo'].includes(asset.assetType) ? asset.id : undefined });
                dispatch(fetchAllAssetsStats({ id: assetId, trackingSchemaId: trackingSchemaId, queries }));
                break;
            default:
                return;
        }
    }),
});
// tables: reset page number to 1 when apply or reset filters
listenerMiddleware.startListening({
    matcher: isAnyOf(setAndApplyInputFilters, resetReduxTableFilters),
    effect: (action_1, _a) => __awaiter(void 0, [action_1, _a], void 0, function* (action, { getState, dispatch }) {
        dispatch(setTablePage(0));
    }),
});
export default listenerMiddleware;
